import { DigitalDossierBankingInformationSerializer } from '@bcba/serializers';
import { FormSection } from '../../DigitalDossier/DigitalDossierSection/components/FormSection';
import { useTranslation } from '@bcba/react-hooks';
import {
  DropzoneReadonly,
  EmptyState,
  FiFileText,
  FiSearch,
  Grid,
  GridItem,
  ReadOnlyField,
} from '@agrotoken-tech/ui';
import {
  formatDateToShortFormat,
  unixTimestampToDate,
} from '@bcba/common-utils';
import { downloadDocument } from '../../../utils/downloadDocument.utils';

type Props = {
  data: DigitalDossierBankingInformationSerializer[];
  companyName: string;
};

export const ReadOnlyBankingInfoSection = ({ data, companyName }: Props) => {
  const { t } = useTranslation();

  const hasBankingInfo = data[0]?.hasBankingInfo ?? false;

  return (
    <FormSection title={t('common.bankData')}>
      {hasBankingInfo ? (
        data.map((account, index) => {
          const { uuid, bankEntity, cbu, cbuDocument } = account;
          const document = cbuDocument?.document;
          return (
            <FormSection
              key={uuid}
              title={t(
                'explorer.digitalDossier.updateBankingInfo.accountSection.title',
              ).replace('{{num}}', String(index + 1))}
            >
              <Grid templateColumns={{ md: 'repeat(2, 1fr)' }} gap={6}>
                <ReadOnlyField
                  label={t(
                    'explorer.digitalDossier.updateBankingInfo.form.bankEntity.label',
                  )}
                  value={bankEntity || '-'}
                />
                <ReadOnlyField
                  label={t(
                    'explorer.digitalDossier.updateBankingInfo.form.cbu.label',
                  )}
                  value={cbu || '-'}
                />
                <GridItem colSpan={{ base: 1, md: 2 }}>
                  <DropzoneReadonly
                    fileName={document?.originalFileName}
                    label={t(
                      'explorer.digitalDossier.updateBankingInfo.form.cbuDocument.label',
                    )}
                    onClick={() => downloadDocument(document?.uuid)}
                    leftIcon={FiFileText}
                  />
                </GridItem>
                <ReadOnlyField
                  label={t(
                    'explorer.digitalDossier.updateBankingInfo.form.documentId.label',
                  )}
                  value={document?.identifier || '-'}
                />
                <ReadOnlyField
                  label={t(
                    'explorer.digitalDossier.updateBankingInfo.form.dueDate.label',
                  )}
                  value={
                    document?.expirationDate
                      ? formatDateToShortFormat(
                          unixTimestampToDate(document.expirationDate),
                        )
                      : '-'
                  }
                />
              </Grid>
            </FormSection>
          );
        })
      ) : (
        <EmptyState
          title={t('sharedDigitalDossier.bankingInfo.emptyState.title')}
          description={t(
            'sharedDigitalDossier.bankingInfo.emptyState.description',
          ).replace('{{companyName}}', companyName)}
          size="md"
          icon={FiSearch}
        />
      )}
    </FormSection>
  );
};
